import { getUnixTime } from "date-fns";
import { useState, useEffect, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import timeStampToDateFormat from "../../../utils/helpers/timestampToDateFormat";

const dateTypeFormat = {
  name: "Full Date",
  format: "dd/MM/yyyy",
  showMonthYearPicker: false,
  showTimeSelect: false,
  showYearPicker: false,
  showTimeSelectOnly: false,
};

const DateTimeLayout = ({
  type,
  minValue,
  maxValue,
  disabled,
  value,
  onChange,
  language,
}) => {
  const [pickerDate, setPickerDate] = useState(value ? new Date() : null);

  useEffect(() => {
    if (value) {
      setPickerDate(
        new Date(timeStampToDateFormat(value, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx'"))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [dateType, setDateType] = useState(dateTypeFormat);

  const DateCustomInput = forwardRef(({ value, onClick, disabled }, ref) => (
    <button
      className="card px-2 d-flex justify-content-start align-items-center text-center"
      style={{
        minWidth: "192px",
        minHeight: "36px",
        width: "100%",
        backgroundColor: disabled ? "#e9ecef" : "#fff",
      }}
      onClick={onClick}
      ref={ref}
      disabled={disabled}
    >
      <span className="mb-0 px-1 py-2">{value}</span>
    </button>
  ));

  useEffect(() => {
    if (type === "YY") {
      setDateType({
        name: "Year",
        format: "yyyy",
        showYearPicker: true,
      });
    } else if (type === "MM/YY") {
      setDateType({
        name: "Month/Year",
        format: "MM/yyyy",
        showMonthYearPicker: true,
      });
    } else if (type === "DD/MM/YY") {
      setDateType({
        name: "Day/Month/Year",
        format: "dd/MM/yyyy",
      });
    } else if (type === "DD/MM/YY HH:MM:SS") {
      setDateType({
        name: "Day/Month/Year",
        format: "dd/MM/yyyy HH:mm",
        showTimeSelect: true,
      });
    } else if (type === "HH:MM:SS") {
      setDateType({
        name: "Hour:Minute:Second",
        format: "HH:mm",
        showTimeSelect: true,
        showTimeSelectOnly: true,
      });
    }
  }, [type]);

  return (
    <div className="w-100">
      <DatePicker
        selected={pickerDate}
        dateFormat={dateType.format}
        showYearPicker={dateType.showYearPicker}
        showMonthYearPicker={dateType.showMonthYearPicker}
        showTimeSelect={dateType.showTimeSelect}
        showTimeSelectOnly={dateType.showTimeSelectOnly}
        popperPlacement={"bottom"}
        onChange={(date) => {
          setPickerDate(date ? new Date(date) : null);
          if (onChange) onChange(date ? getUnixTime(new Date(date)) : null);
        }}
        customInput={<DateCustomInput disabled={disabled} />}
        locale={dateType.locale || language || "tr"}
        timeFormat={"HH:mm"}
        disabled={disabled}
        isClearable={!disabled}
        wrapperClassName="w-100"
        className="w-100"
        minDate={
          minValue
            ? new Date(
                timeStampToDateFormat(minValue, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
              )
            : null
        }
        maxDate={
          maxValue
            ? new Date(
                timeStampToDateFormat(maxValue, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
              )
            : null
        }
      />
    </div>
  );
};
export default DateTimeLayout;
